import React from 'react';
import snapshot from './historicalTrackFilterReference.json';

const currency = (value: number) => new Intl.NumberFormat('en-AU', {
  style: 'currency', currency: 'AUD', maximumFractionDigits: 0,
}).format(value);
const percent = (value: number | null) => value == null ? '?' : value.toFixed(2) + '%';

const HistoricalTrackFilterReference: React.FC = () => (
  <section className="sr-card" aria-labelledby="historical-track-filter-title" style={{ marginTop: 28, padding: 16 }}>
    <h2 id="historical-track-filter-title">Historical track-filter results</h2>
    <p className="rc-note">
      Reference snapshot ? 30 September 2026 ? 13 of 40 buckets.
      Shown only where a historical filter lowered dollar drawdown, did not extend calendar drawdown,
      remained profitable, and retained at least 30 bets.
    </p>
    <p className="rc-note">
      Tracks ranked by 2020?2022 Core rank 1?3 winner counts.
      ?Top 2/day? means the two highest-ranked venues racing that day.
      Figures show <strong>all tracks ? historical filter</strong>, at flat $100 stakes after 10% commission.
      WIN and PLACE results are separate.
    </p>
    <div style={{ overflowX: 'auto' }}>
      <table role="table" className="sr-table mobile-card-table" aria-label="Historical track-filter drawdown comparison">
        <thead role="rowgroup"><tr role="row">
          <th role="columnheader">Bucket</th>
          <th role="columnheader">Historical filter</th>
          <th role="columnheader">Retained bets</th>
          <th role="columnheader">Profit</th>
          <th role="columnheader">ROI</th>
          <th role="columnheader">DD $</th>
          <th role="columnheader">DD days</th>
          <th role="columnheader">DD bets</th>
        </tr></thead>
        <tbody role="rowgroup">{snapshot.rows.map(row => (
          <tr role="row" key={row.id}>
            <td role="cell" data-label="Bucket">
              <strong>{row.label}</strong>
              <div className="rc-note">{row.market} ? {row.side.toUpperCase()} ? {row.baseline.first} to {snapshot.cutoff}</div>
            </td>
            <td role="cell" data-label="Historical filter">Top {row.tracks}/day</td>
            <td role="cell" data-label="Retained bets" className="sr-num">{row.filtered.bets} / {row.baseline.bets}</td>
            <td role="cell" data-label="Profit" className="sr-num">{currency(row.baseline.profit)} ? {currency(row.filtered.profit)}</td>
            <td role="cell" data-label="ROI" className="sr-num">{percent(row.baseline.roi)} ? {percent(row.filtered.roi)}</td>
            <td role="cell" data-label="DD $" className="sr-num">{currency(row.baseline.max_dd)} ? {currency(row.filtered.max_dd)}</td>
            <td role="cell" data-label="DD days" className="sr-num">{row.baseline.dd_days} ? {row.filtered.dd_days}</td>
            <td role="cell" data-label="DD bets" className="sr-num">{row.baseline.dd_bets} ? {row.filtered.dd_bets}</td>
          </tr>
        ))}</tbody>
      </table>
    </div>
    <details style={{ marginTop: 12 }}>
      <summary>How to read this historical comparison</summary>
      <p className="rc-note">
        Each row shows the qualifying filter with the shortest calendar drawdown;
        ties use greater profit, then smaller dollar drawdown.
        DD $ is maximum peak-to-trough loss. DD days and DD bets are maximum peak-to-recovery durations,
        including ongoing drawdowns through 30 September. These maxima can occur in different episodes.
      </p>
      <p className="rc-note">
        Available 2026 history begins in June or later, varying by bucket.
        The archived Core model ranks the venues; bucket results mix retrospective and forward records.
        This is a fixed research snapshot, not a forward-validated result. Thirty bets is a display threshold.
        A shorter recovery relative to baseline can still take many weeks.
      </p>
      <p className="rc-note">
        Venue counts combine Sandown courses, Morphettville/Parks, Newcastle/Beaumont,
        Pinjarra/Scarpside and Wagga/Riverside. Unknown historical venues are excluded by the filters.
      </p>
    </details>
  </section>
);

export default HistoricalTrackFilterReference;
